import routes from '../../../app/routes';

export const ADMIN_ACCOUNT_SECTIONS = [
  {
    key: 'accountProfile',
    routeKey: 'root',
    exact: true,
    labelId: 'admin.accountManagement.accountDetail.accountProfile',
    icon: 'building',
  },
  {
    key: 'commodityTypes',
    routeKey: 'commodityTypes',
    labelId: 'admin.accountManagement.accountDetail.commodityTypes',
    icon: 'boxes',
  },
  {
    key: 'temperatureDevices',
    routeKey: 'temperatureDevices',
    labelId: 'admin.accountManagement.accountDetail.temperatureDevices',
    icon: 'thermometer-half',
  },
  {
    key: 'packageTypes',
    routeKey: 'packageTypes',
    labelId: 'admin.accountManagement.accountDetail.packageTypes',
    icon: 'box',
  },
  {
    key: 'packageTemperatures',
    routeKey: 'packageTemperatures',
    labelId: 'admin.accountManagement.accountDetail.packageTemps',
    icon: 'temperature-low',
  },
];

export const getSectionRoute = section =>
  routes.admin.accountDetail[section.routeKey];
